/*
 * Copyright 2021 The Kubeflow Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const px = (number: number): string => `${number}px`;

export const CARD_RADIUS = 6;
export const CARD_CONTAINER_BORDERS = 2;
export const CARD_TITLE_BASE_HEIGHT = 40;
export const CARD_TITLE_BORDER_BOTTOM_HEIGHT = 1;
export const CARD_TITLE_HEIGHT = CARD_TITLE_BASE_HEIGHT + CARD_TITLE_BORDER_BOTTOM_HEIGHT;
export const CARD_SPACER_HEIGHT = 24;
export const CARD_ROW_HEIGHT = 67;
